import React from 'react';
import { Section } from './ui/Section';
import { AlertTriangle, Paintbrush, Store } from 'lucide-react';
export function WhyFail() {
  return <Section className="bg-brand-dark" data-id="element-355">
      <div className="max-w-4xl mx-auto" data-id="element-356">
        <div className="mb-12" data-id="element-357">
          <p className="text-slate-400 text-lg mb-4" data-id="element-358">
            Y lo más frustrante de todo es que probablemente ya lo intentaste.
          </p>
          <p className="text-slate-300 text-lg leading-relaxed mb-12" data-id="element-359">
            Quizás usaste una plantilla gratuita de Wix. Quizás le pediste ayuda
            a alguien que "sabe de computadores". Quizás incluso pagaste por una
            web que se veía bien... pero nunca te trajo un solo cliente.
          </p>

          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-360">
            ¿Por Qué la Mayoría de las Webs de Emprendedores Fracasan?
          </h2>

          <div className="flex items-start gap-4 p-6 bg-brand-surface/50 border-l-4 border-brand-accent rounded-r-xl mb-12" data-id="element-361">
            <AlertTriangle className="w-6 h-6 text-brand-accent flex-shrink-0 mt-1" data-id="element-362" />
            <div data-id="element-363">
              <p className="text-sm font-semibold text-brand-accent uppercase tracking-wider mb-2" data-id="element-364">
                Aquí está la verdad que nadie te dice:
              </p>
              <p className="text-2xl font-bold text-white" data-id="element-365">
                Una web bonita no es una web que convierte.
              </p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-366">
          <div className="bg-brand-surface border border-white/5 p-8 rounded-2xl" data-id="element-367">
            <Paintbrush className="w-8 h-8 text-slate-400 mb-6" data-id="element-368" />
            <p className="text-lg text-slate-300 leading-relaxed" data-id="element-369">
              La mayoría de diseñadores web son artistas. Crean algo visualmente
              atractivo. Pero{' '}
              <strong className="text-white" data-id="element-370">
                no tienen ni idea de marketing, psicología del comprador ni
                estrategia de conversión.
              </strong>
            </p>
            <p className="text-lg text-slate-300 mt-4" data-id="element-371">
              ¿El resultado? Una página que parece profesional pero que no
              genera ni una sola consulta.
            </p>
          </div>

          <div className="bg-brand-surface border border-brand-accent/20 p-8 rounded-2xl relative overflow-hidden group hover:border-brand-accent/50 transition-colors" data-id="element-372">
            <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-373">
              <Store className="w-32 h-32 text-brand-accent" data-id="element-374" />
            </div>
            <Store className="w-8 h-8 text-brand-accent mb-6 relative z-10" data-id="element-375" />
            <p className="text-xl font-medium text-white leading-relaxed relative z-10 italic" data-id="element-376">
              "Es como tener una tienda perfectamente decorada... en el medio
              del desierto. Nadie la ve, y los que llegan no saben qué hacer ni
              por qué deberían comprarte a ti."
            </p>
          </div>
        </div>
      </div>
    </Section>;
}